import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AnimatePresence } from "framer-motion";
import { LanguageProvider } from "@/context/LanguageContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Lieu from "@/components/Lieu";
import People from "@/components/People";
import Bureau from "@/components/Bureau";
import Events from "@/components/Events";
import Boutique from "@/components/Boutique";
import Journal from "@/components/Journal";
import Presence from "@/components/Presence";
import Inauguration from "@/components/Inauguration";
import Fresque from "@/components/Fresque";
import Gallery from "@/components/Gallery";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AudioPlayer from "@/components/AudioPlayer";
import IntroSeal from "@/components/IntroSeal";
import Admin from "@/pages/Admin";
import Artwork from "@/pages/Artwork";

function Site() {
  const [introDone, setIntroDone] = useState(() => sessionStorage.getItem("mas:intro") === "1");

  const finishIntro = () => {
    sessionStorage.setItem("mas:intro", "1");
    setIntroDone(true);
  };

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (!introDone) return;
    const hash = window.location.hash;
    if (!hash) return;
    const timer = setTimeout(() => {
      if (window.__lenis) window.__lenis.scrollTo(hash, { duration: 1.2 });
      else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    }, 450);
    return () => clearTimeout(timer);
  }, [introDone]);

  return (
    <div className="min-h-screen bg-ink text-parchment">
      <AnimatePresence>
        {!introDone && <IntroSeal onDone={finishIntro} />}
      </AnimatePresence>
      {introDone && <Navbar />}
      <main>
        {introDone && <Hero />}
        <Marquee />
        <Inauguration />
        <Manifesto />
        <Lieu />
        <People />
        <Bureau />
        <Events />
        <Presence />
        <Fresque />
        <Boutique />
        <Journal />
        <Gallery />
        <Contact />
      </main>
      <Footer />
      {introDone && <AudioPlayer />}
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site />} />
          <Route path="/oeuvres/:id" element={<Artwork />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster theme="dark" position="bottom-left" toastOptions={{ style: { background: "rgb(var(--ink2))", border: "1px solid rgb(var(--gold) / 0.3)", color: "rgb(var(--parchment))" } }} />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
